import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import dayjs from 'dayjs';

export const formatDate = Intl.DateTimeFormat('en-US').format;

export const formatCurrency = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format;

export const formatCardExpirationDate = (month: string, year: string) =>
  dayjs(`${month}-${year}`, 'M-YYYY').format('MM/YY');

export const formatList = (list: Array<string>) => {
  if (list.length === 0) return '';
  if (list.length === 1) return list[0];
  if (list.length === 2) return `${list[0]} and ${list[1]}`;
  return `${list.slice(0, -1).join(', ')} and ${list[list.length - 1]}`;
};

export const formatQueryError = (
  error: FetchBaseQueryError | SerializedError,
) => {
  const { data } = error as any;
  if (typeof data === 'object' && data !== null && 'message' in data) {
    return data.message;
  }
  if ('status' in error) {
    if ('data' in error) {
      if (
        typeof error.data === 'object' &&
        error.data !== null &&
        'error' in error.data
      ) {
        return `${error.data.error}`;
      }
      return `${error.status}: ${error.data}`;
    }
    return error.status;
  }
  return `An unexpected error occurred: ${error}`;
};
